import axios from 'axios';

const { get, post, patch } = axios;

export const getPathway = (pathwayId, params = {}, config = {}) =>
  get(`/v1/pathways/${pathwayId}/`, { params, ...config });
export const getPathways = (projectId, params = {}) => get(`/v1/projects/${projectId}/pathways/`, { params });
export const disconnectInputFromOutput = (pathwayId, data) => post(`/v1/pathways/${pathwayId}/disconnect/`, data);
export const connectInputToOutput = (pathwayId, data) => post(`/v1/pathways/${pathwayId}/connect/`, data);
export const createPathway = (projectId, data) => post(`/v1/projects/${projectId}/pathways/`, data);
export const patchPathway = (pathwayId, data) => patch(`/v1/pathways/${pathwayId}/`, data);
export const deletePathway = pathwayId => axios.delete(`/v1/pathways/${pathwayId}/`);
export const bulkDeletePathways = (projectId, data) =>
  axios.delete(`/v1/projects/${projectId}/pathways/bulk_delete/`, { data });
export const bulkDuplicatePathways = (projectId, data) =>
  post(`/v1/projects/${projectId}/pathways/bulk_duplicate/`, data);
export const bulkBalancePathways = (projectId, data) => post(`/v1/projects/${projectId}/pathways/bulk_balance/`, data);
export const bulkAnalyzePathways = (projectId, data) => post(`/v1/projects/${projectId}/pathways/bulk_analyze/`, data);
export const lockPathway = pathwayId => axios.post(`/v1/pathways/${pathwayId}/lock/`);
export const unlockPathway = pathwayId => axios.post(`/v1/pathways/${pathwayId}/unlock/`);
export const getPathwayRevisions = (pathwayId, params = {}) => get(`/v1/pathways/${pathwayId}/revisions/`, { params });
export const restorePathwayRevision = (pathwayId, revisionId) =>
  post(`/v1/pathways/${pathwayId}/revisions/${revisionId}/restore/`);

export const getPathwayParamInfo = () => get(`/v1/pathways/params/`);

export const getPathwayParams = pathwayId => get(`/v1/pathways/${pathwayId}/params/`);
export const patchPathwayParams = (pathwayId, data) => patch(`/v1/pathways/${pathwayId}/params/`, data);
export const createPathwayCustomProperty = (pathwayId, data) =>
  post(`/v1/pathways/${pathwayId}/custom_properties/`, data);
export const updatePathwayCustomProperty = (pathwayId, propertyName, data) =>
  patch(`/v1/pathways/${pathwayId}/custom_properties/${propertyName}/`, data);
export const deletePathwayCustomProperty = (pathwayId, propertyName) =>
  axios.delete(`/v1/pathways/${pathwayId}/custom_properties/${propertyName}/`);
export const duplicateNodes = (pathwayId, data) => post(`/v1/pathways/${pathwayId}/duplicate_nodes/`, data);
export const createPathwayForTemplate = data => post(`/v1/pathway_templates/create_pathways/`, data);
